<template>
  <div>
    <div v-if="Object.keys(errors).length > 0" class="alert alert-danger">
      <p v-for="error in errors" class="errors">
        {{ error }}
      </p>
    </div>
    <div>
      <select :value="study_group_category_id" name="study_group_category_id" class="form-control" @change="handleChange">
        <option value="">Select Category</option>
        <option v-for="category in config.studyCategories" :value="category.id">
          {{ category.name }}
        </option>
      </select>
    </div>
    <div v-if="study_group_category_id">
      <select :value="operator" name="operator" class="form-control" @change="handleChange">
        <option value="isOneOf">is one of</option>
        <option value="isNull">is not assigned</option>
      </select>
      <div v-if="showGroupOptions">
        <label v-for="(value, key) in filteredGroups" :key="key" class="d-block">
          <input
            v-model="selectedStudyGroups"
            :value="value.id"
            type="checkbox"
            name="study_group_ids"
          >
          {{ value.name }}
        </label>
      </div>
    </div>
  </div>
</template>

<script>
import BaseComponent from '@/EventLogic/components/BaseComponent.vue';
import {unaryOperators} from "@/EventLogic/operators";

export default {
  name: "IfStudyGroup",
  extends: BaseComponent,
  props: {
    'study_group_category_id': {
      type: String,
    },
    'operator': {
      type: String,
      default: 'isOneOf'
    },
    'study_group_ids': {
      type: Array,
      default: () => []
    },
    id: String,
  },
  data: function () {
    return {
      selectedStudyGroups: this.study_group_ids,
    }
  },
  watch: {
    selectedStudyGroups() {
      this.$emit('update:study_group_ids', this.selectedStudyGroups);
    },
    'study_group_category_id'() {
      // wipe study group selection when changing categories
      this.selectedStudyGroups = []
    },
    operator(newVal) {
      console.log(newVal);
      // wipe study group selection if operator is not isOneOf
      if (newVal !== 'isOneOf') {
        this.selectedStudyGroups = []
      }
    }
  },
  computed: {
    showGroupOptions() {
      return this.operator === 'isOneOf';
    },
    filteredGroups() {
      return this.config.studyGroups.filter(group => group.category_id.toString() === this.study_group_category_id.toString()) ?? [];
    },
    operatorTakesArgs: function() {
      return unaryOperators.includes(this.operator) === false;
    }
  },
  methods: {
    validate: function() {
      this.errors = {};
      if (!this.study_group_category_id) {
        this.errors.variable = 'Please select an access group category.';
      } else {
        if (!this.operator) {
          this.errors.operator = "Please select a comparison operator.";
        }

        if (this.operatorTakesArgs) {
            if (this.study_group_ids.length < 1) {
              this.errors.study_group_ids = "Please select at least one access group.";
            }
        }
      }

      return Object.keys(this.errors).length === 0;
    }
  }
}
</script>

<style scoped>

</style>
